export const environment = {
    production: true,
    apiBaseUrl: "https://lutzangeles-api-h8g7ftfzckbpb9ge.westus-01.azurewebsites.net/",
    registeredDomain: "lutzangeles.com",
    authentication: {
        google: {
            clientId: "660557447755-qav8mfmv1sic104t5b5ce7ps9i5sptg9.apps.googleusercontent.com",
            redirectUri: "https://{FQDN}/logincallback/google"
        },
        instagram: {
            AppId: "1407071206967887", // "3741087766137790",
            redirectUri: "https://{FQDN}/logincallback/instagram"
        }
    }
};
